
<div *ngIf="init">
    <dynamic-form  [layout]="alignMent" 
    [customField13]="0" [fields]="regConfig"
     (submit)="submitValue($event)">
    </dynamic-form>
</div>